import {Component, forwardRef, ChangeDetectorRef, Injector, OnInit, OnDestroy, Output, EventEmitter, NgZone} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NewlandScannerModel } from '../newland-scanner.model';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';
import { WorkflowComponentsService } from '../../workflow-components.service';
import { PlatformService } from 'src/app/core-api/platform/platform.service';

@Component({
    selector: 'abw-newland-scanner-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => NewlandScannerFormComponent),
        multi: true
      }
    ],
    templateUrl: './newland-scanner-form.component.html',
    styleUrls: ['./newland-scanner-form.component.scss']
})
export class NewlandScannerFormComponent extends AbstractWorkflowFormComponent<NewlandScannerModel, string> implements OnInit, OnDestroy {
  @Output() onScanned = new EventEmitter();

  constructor(
    private platformService: PlatformService,
    _workflowComponentsService: WorkflowComponentsService,
    _cdf: ChangeDetectorRef,
    _injector: Injector,
    private zone: NgZone,
  ) {
      super(_workflowComponentsService, _cdf, _injector);
  }

  ngOnInit() {
    super.ngOnInit();
    if (!!window['AndroidApi'] && !window['AndroidApi'].doTriggerNewlandScan) {
      window['AndroidApi'].doTriggerNewlandScan = () => {
        this.scanCode();
      }
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (!!window['AndroidApi']?.doTriggerNewlandScan) {
      delete window['AndroidApi'].doTriggerNewlandScan;
    }
  }

  async scanCode() {
    try {
      const result = await this.platformService.newlandStartScan();
      this.onValueChanged(result);
      this.onScanned.emit(result);
    } catch(e) {
      console.error(e);
    }
  }
}